import { getNews } from "../api/news.js";
import { listAllMedia } from "./media.js";
import { addNotification } from "./notifications.js";
import { todayDate } from "../utils/dates.js";
import { loadNewsPrefs, applyNewsPrefs, newsNoticesFor, bellCountToday, addBellCount } from "../utils/news-prefs.js";

// Opt-in bell notices for news about the library (design_documents/news.md §9;
// Newsstand → Setup → The bell). Runs in the daily maintenance; at most three a
// day; ids ("news:<story id>") dedupe, so a story never rings twice. Fetching
// the wire here also refreshes the issue Home's strip and "In the news" read.
export async function runNewsBell({ today = todayDate() } = {}) {
	const prefs = loadNewsPrefs();
	if (!prefs.bell) return 0;
	if (typeof navigator !== "undefined" && navigator.onLine === false) return 0;
	const postedToday = bellCountToday(today);
	if (postedToday >= 3) return 0;
	const { data, stale } = await getNews();
	if (stale) return 0;
	const notices = newsNoticesFor(applyNewsPrefs(data.items ?? [], prefs), await listAllMedia(), { postedToday });
	let posted = 0;
	for (const n of notices) if (await addNotification(n)) posted++;
	if (posted) addBellCount(today, posted);
	return posted;
}
